"use client";

import { Tabs, TabsList, TabsTrigger } from "@workspace/ui/components/tabs";
import { memo } from "react";

interface ArtistContentTabsProps {
	activeContentType: "festivals" | "sets" | "shows";
	onContentTypeChange: (value: string) => void;
	counts: {
		festivals: number;
		sets: number;
		shows: number;
	};
}

export const ArtistContentTabs = memo(function ArtistContentTabs({
	activeContentType,
	onContentTypeChange,
	counts,
}: ArtistContentTabsProps) {
	return (
		<Tabs
			value={activeContentType}
			onValueChange={onContentTypeChange}
			className="w-full"
		>
			<TabsList className="grid w-full grid-cols-3 gap-1">
				<TabsTrigger value="festivals" className="group relative w-full">
					Festivals{" "}
					<span className="!opacity-100 ml-2 hidden rounded-md px-1.5 py-0.5 font-medium text-xs group-data-[state=inactive]:border group-data-[state=active]:bg-muted group-data-[state=inactive]:bg-transparent sm:inline">
						{counts.festivals}
					</span>
				</TabsTrigger>
				<TabsTrigger value="sets" className="group relative w-full">
					Sets{" "}
					<span className="!opacity-100 ml-2 hidden rounded-md px-1.5 py-0.5 font-medium text-xs group-data-[state=inactive]:border group-data-[state=active]:bg-muted group-data-[state=inactive]:bg-transparent sm:inline">
						{counts.sets}
					</span>
				</TabsTrigger>
				<TabsTrigger value="shows" className="group relative w-full">
					Shows{" "}
					<span className="!opacity-100 ml-2 hidden rounded-md px-1.5 py-0.5 font-medium text-xs group-data-[state=inactive]:border group-data-[state=active]:bg-muted group-data-[state=inactive]:bg-transparent sm:inline">
						{counts.shows}
					</span>
				</TabsTrigger>
			</TabsList>
		</Tabs>
	);
});

ArtistContentTabs.displayName = "ArtistContentTabs";
